import angular from 'angular';

CapitalizeFirstLetterFilter.$inject = [];

export function capFirstLetter(value?: string) {
  if (!value) {
    return '';
  }

  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

function CapitalizeFirstLetterFilter() {
  return capFirstLetter;
}

export const CapitalizeFirstLetterFilterModule = angular
  .module('acme.common.filter.capitalizeFirstLetter', [])
  .filter('capitalizeFirstLetter', CapitalizeFirstLetterFilter).name;
